export default class Employer {
    static FIELDS = [
        {field: 'uuid', rowField: 'uuid', valid: v => typeof v === 'string', complete: v => v !== ''},
        {field: 'name', rowField: 'name', valid: v => typeof v === 'string', complete: v => v !== ''},
        {field: 'identifier', rowField: 'identifier', valid: v => typeof v === 'string', complete: v => v !== ''},
        {field: 'address', rowField: 'address', valid: v => typeof v === 'string', complete: () => true},
        {field: 'zip', rowField: 'zip', valid: v => typeof v === 'string', complete: v => v !== ''},
        {field: 'city', rowField: 'city', valid: v => typeof v === 'string', complete: v => v !== ''},
        {field: 'state', rowField: 'state', valid: v => typeof v === 'string', complete: v => v !== ''}
    ]

    static fromObject (o) {
        if (typeof o !== 'object') {
            throw new Error('cannot load employer entry from non-object')
        }

        var res = new Employer()
        var problems = []
        this.FIELDS.forEach(f => {
            if (!f.valid(o[f.field])) {
                problems.push(f.field)
            } else {
                res[f.field] = o[f.field]
            }
        })

        if (problems.length > 0) {
            throw new Error(`missing entry data or invalid values for: ${JSON.stringify(problems)}`)
        }

        return res
    }

    constructor () {
        this.uuid = ''
        this.name = ''
        this.identifier = ''
        this.address = ''
        this.zip = ''
        this.city = ''
        this.state = ''
    }

    findDataProblems (ignore = []) {
        var problems = []
        Employer.FIELDS.forEach(f => {
            if (!ignore.includes(f.field) && !f.complete(this[f.field])) {
                problems.push(f.field)
            }
        })

        return problems
    }
}
